import { useContext } from "react";
import { AppConfigContext } from "../contexts/AppConfigContext";

export function useAppConfig() {
    const value = useContext(AppConfigContext);
    return value;
}